import { useState, useEffect, useCallback } from 'react';
import { AxiosError } from 'axios';
import { Article, ArticleType, useArticlesGet } from './articles';
import { DefaultFetchError } from '../fetch';
import { useMessageError } from '../common';

export interface SingleArticleFetchResult {
  data: Article | undefined;
  loading: boolean;
  error: AxiosError<DefaultFetchError> | null;
  refetch: () => void;
}

export const useSingleArticleByType = (articleType: ArticleType): SingleArticleFetchResult => {
  const articlesGet = useArticlesGet();
  const { fetch: fetchList, loading, error } = articlesGet;

  const [data, setData] = useState<Article | undefined>();

  const fetchArticle = useCallback(async () => {
    try {
      const response = await fetchList({
        articleType,
        pageSize: 1,
        page: 1,
      });

      /** Set the local data based on the response */
      if (response && response.data && response.data.length > 0) {
        setData(response.data[0]);
      } else {
        setData(undefined);
      }
    } catch (error_) {
      /** Ensure our local data is cleared in case of an error. */
      setData(undefined);
      console.error('Failed to fetch single article by type:', error_);
    }
  }, [articleType, fetchList]);

  useEffect(() => {
    fetchArticle();
  }, [fetchArticle]);

  useMessageError([articlesGet]);

  return {
    data, loading, error, refetch: fetchArticle,
  };
};
